import { render } from "./PaginationComponent.vue?vue&type=template&id=1aee8a96&ts=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts"

import "./PaginationComponent.vue?vue&type=style&index=0&id=1aee8a96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__